import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ paddedRows?: boolean }>()(
  (theme, { paddedRows = false }) => ({
    row: {
      justifyContent: 'space-between',
      // Top-aligned so the label stays level with the first line of a value
      // that wraps, such as an address.
      alignItems: 'flex-start',
      width: '100%',
      ...(paddedRows
        ? { padding: `${theme.new.spacing.medium} 0`, marginBottom: 0 }
        : { marginBottom: '8px' }),
    },
    label: {
      color: theme.new.color.grey[600],
      fontSize: '0.875rem',
      flexShrink: 0,
    },
    value: {
      fontSize: '0.875rem',
      textAlign: 'right',
      flex: 1,
      minWidth: 0,
    },
    divider: {
      borderColor: theme.new.color.line.hairline,
      marginBottom: paddedRows ? 0 : '8px',
    },
  })
);

export default useStyles;
